// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import pageLoading from './plugins/pageLoading'
import VueWechatTitle from 'vue-wechat-title'
import Config from './config'
// import Vconsole from 'vconsole'

import sixBridge from './plugins/sixBridge/index'
import permission from './utils/permission'

// MintUI
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'

// VueAwesomeSwiper
import VueAwesomeSwiper from 'vue-awesome-swiper'
// require styles
import 'swiper/dist/css/swiper.css'

// 图片懒加载
import VueLazyload from 'vue-lazyload'
import infiniteScroll from 'vue-infinite-scroll'

// 全局公用样式
import '@/assets/css/base-style.less'
// 设置 PX 转 Rem （单位换算）
import '@/utils/pxConvertRem'

// 全局函数
import globalFunction from './globalFunction'

// 全局变量
import globalVariable from './globalVariable'

// 路由权限控制
permission(router)

Vue.prototype.GLOBAL = globalVariable
Vue.prototype.$config = Config

/* eslint-disable */ // 手机端 console
// new Vconsole()

import '@/utils/randomNicknameColour'
import VueTouch from 'vue-touch'
Vue.use(VueTouch, { name: 'v-touch' })

Vue.use(sixBridge)
Vue.use(VueWechatTitle)
Vue.use(pageLoading)
Vue.use(globalFunction)
Vue.use(VueLazyload)
Vue.use(infiniteScroll)
Vue.use(MintUI)
Vue.use(VueAwesomeSwiper)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js